
// Minimal EventEmitter implementation for browser
class EventEmitter {
    constructor() {
        this.events = {};
    }
    on(event, listener) {
        if (!this.events[event]) this.events[event] = [];
        this.events[event].push(listener);
        return this;
    }
    off(event, listener) {
        if (!this.events[event]) return this;
        this.events[event] = this.events[event].filter(l => l !== listener);
        return this;
    }
    emit(event, ...args) {
        if (!this.events[event]) return false;
        this.events[event].forEach(listener => listener.apply(this, args));
        return true;
    }
}
import { lerp, getMousePos, calcWinsize, distance, getRandomFloat } from './utils.js';

// body color
const bodyColor = getComputedStyle(document.body).getPropertyValue('--color-bg');

// Calculate the viewport size
let winsize = calcWinsize();
window.addEventListener('resize', () => winsize = calcWinsize());

// Track the mouse position
let mousepos = {x: 0, y: 0};
window.addEventListener('mousemove', ev => mousepos = getMousePos(ev));

export default class ButtonCtrl extends EventEmitter {
    constructor(el) {
        super();
        // DOM elements
        // el: main button
        // text: inner text element
        this.DOM = {el: el};
        this.DOM.text = this.DOM.el.querySelector('.button__text');
        this.DOM.textinner = this.DOM.el.querySelector('.button__text-inner');
        this.DOM.deco = this.DOM.el.querySelector('.button__deco');
        this.DOM.filler = this.DOM.deco.querySelector('.button__deco-filler');
        // amounts the button will translate/scale
        this.renderedStyles = {
            tx: {previous: 0, current: 0, amt: 0.1},
            ty: {previous: 0, current: 0, amt: 0.1},
            scale: {previous: 1, current: 1, amt: 0.2}
        };

        // button state (hover)
        this.state = {
            hover: false
        };
        // calculate size/position
        this.calculateSizePosition();
        // init events
        this.initEvents();
        // loop fn
        requestAnimationFrame(() => this.render());
    }
    calculateSizePosition() {
        // Calculate the trigger distance based on the button's width.
        // This only needs to be done on init and resize.
        const rect = this.DOM.el.getBoundingClientRect();
        this.distanceToTrigger = rect.width * 0.60;
    }
    initEvents() {
        this.onResize = () => this.calculateSizePosition();
        window.addEventListener('resize', this.onResize);
    }
    render() {
        // Get the button's current size and position relative to the viewport on every frame.
        this.rect = this.DOM.el.getBoundingClientRect();
        
        // Calculate the distance from the mouse (viewport coords) to the center of the button (viewport coords).
        const distanceMouseButton = distance(mousepos.x, mousepos.y, this.rect.left + this.rect.width/2, this.rect.top + this.rect.height/2);
        
        // New values for the translations
        let x = 0;
        let y = 0;

        if ( distanceMouseButton < this.distanceToTrigger ) {
            if ( !this.state.hover ) {
                this.enter();
            }
            // Calculate translation based on viewport-relative positions.
            x = (mousepos.x - (this.rect.left + this.rect.width/2)) * 0.3;
            y = (mousepos.y - (this.rect.top + this.rect.height/2)) * 0.3;
        }
        else if ( this.state.hover ) {
            this.leave();
        }

        this.renderedStyles['tx'].current = x;
        this.renderedStyles['ty'].current = y;
        
        for (const key in this.renderedStyles ) {
            this.renderedStyles[key].previous = lerp(this.renderedStyles[key].previous, this.renderedStyles[key].current, this.renderedStyles[key].amt);
        }
        
        this.DOM.el.style.transform = `translate3d(${this.renderedStyles['tx'].previous}px, ${this.renderedStyles['ty'].previous}px, 0)`;
        this.DOM.text.style.transform = `translate3d(${-this.renderedStyles['tx'].previous*0.2}px, ${-this.renderedStyles['ty'].previous*0.2}px, 0)`;
        this.DOM.deco.style.transform = `scale(${this.renderedStyles['scale'].previous})`;

        requestAnimationFrame(() => this.render());
    }
    enter() {
        this.emit('enter');
        this.state.hover = true;

        this.DOM.el.classList.add('button--hover');
        
        // this.renderedStyles['scale'].current = 1.3;
        this.renderedStyles['scale'].current = 1;
        
        window.gsap.killTweensOf(this.DOM.filler);
        window.gsap.killTweensOf(this.DOM.textinner);

        window.gsap
        .timeline()
        .to(this.DOM.filler, 0.5, {
            ease: 'Power3.easeOut',
            startAt: {y: '75%'},
            y: '0%'
        }, 0)
        .to(this.DOM.textinner, 0.4, {
            ease: 'Expo.easeOut',
            scale: 1
        }, 0);
    }
    leave() {
        this.emit('leave');
        this.state.hover = false;

        this.DOM.el.classList.remove('button--hover');
        
        this.renderedStyles['scale'].current = 1;

        window.gsap.killTweensOf(this.DOM.filler);

        window.gsap
        .timeline()
        .to(this.DOM.filler, 0.4, {
            ease: 'Power3.easeOut',
            y: '-75%'
        }, 0)
        .to(this.DOM.textinner, 0.4, {
            ease: 'Expo.easeOut',
            scale: 1
        }, 0);
    }
}

window.addEventListener('load', () => {
    for (const button of document.querySelectorAll('.button-magnetic')) {
        // Initialize ButtonCtrl for each button
        new ButtonCtrl(button);
    }
});
